import PropTypes from "prop-types";

import Presenter from "utils/PropTypesPresenter";
import CategoryPresenter from "presenters/CategoryPresenter";

export default new Presenter(
  {
    id: PropTypes.string,
    name: PropTypes.string,
    type: PropTypes.string,
    categories: PropTypes.arrayOf(CategoryPresenter.shape()),
  },
  {},
);
